import React from "react";
import YouTube, { YouTubeProps } from "react-youtube";

const MovieClip: React.FC = () => {
  const options: YouTubeProps["opts"] = {
    width: "90%",
    height: "390",
    playerVars: {
      autoplay: 1,
      controls: 1,
    },
  };

  const onReady: YouTubeProps["onReady"] = (event) => {
    event.target.pauseVideo();
  };

  return (
    <YouTube
      videoId="UmGqx2-rZWE"
      opts={options}
      onReady={onReady}
      id="video"
      className="mt-3"
    />
  );
};

export default MovieClip;